export default __webpack_public_path__ + "static/media/deposit-ico.5d6b0f6a.webp";